import React, { useState, useEffect } from 'react';
import apiGlobal from '../../../global/api.global';
import { VesselMachineryList } from '../VesselConfiguration.model';
import { Button, Col, Label, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../../../';
import { successToast } from '../../../Components/Toasts';

export default function GeneralSettings() {
  const [vesselMachineryFC, setVesselMachineryFC] = useState<Array<VesselMachineryList>>([]);
  const [vesselMachineryEC, setVesselMachineryEC] = useState<Array<VesselMachineryList>>([]);
  const [specialOperationsFuel, setSpecialOperationsFuel] = useState<Array<any>>([]);
  const [specialOperationsEnergy] = useState<Array<any>>([]);
  const [specialOpsFC, setSpecialOpsFC] = useState<Array<any>>([]);
  const [specialOpsEC, setSpecialOpsEC] = useState<Array<any>>([]);
  const { VesselID, Vessels } = useSelector((state: RootState) => state.Reporting);
  const vessel = Vessels.find((rec: any) => rec.id === VesselID);

  useEffect(() => {
    const loadMachineryOptions = async () => {
      try {
        const response = await apiGlobal.get(`vessel_machinery_fc_group/get_vessel_machinery_fc_group_by_vessel/?vessel_id=${VesselID}`);
        setVesselMachineryFC(response.data);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    }; loadMachineryOptions();
  }, [VesselID]);

  useEffect(() => {
    const loadMachineryOptions = async () => {
      try {
        const response = await apiGlobal.get(`/vessel_machinery_ec_group/get_vessel_machinery_ec_group_by_vessel/?vessel_id=${VesselID}`);
        setVesselMachineryEC(response.data);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    }; loadMachineryOptions();
  }, [VesselID]);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await apiGlobal.get(`special_operation_fuel_setting/get_special_operation_fuel_setting_by_vessel/?vessel_id=${VesselID}`);
        setSpecialOpsFC(response.data);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    }; loadSettings();
  }, [VesselID]);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await apiGlobal.get(`special_operation_energy_setting/get_special_operation_energy_setting_by_vessel/?vessel_id=${VesselID}`);
        setSpecialOpsEC(response.data);
        return response.data;
      } catch (error) {
        console.log(error);
      }
    }; loadSettings();
  }, [VesselID]);

  useEffect(() => {
    if (vesselMachineryFC.length > 0) {
      const newSpecialOperationsFuel = [...specialOperationsFuel];

      vesselMachineryFC.forEach((machine: any, index: number) => {
        if (index >= newSpecialOperationsFuel.length) {
          newSpecialOperationsFuel.push({
            vessel_name: VesselID,
            vessel_machinery_fc_group: machine.id,
            cargo_heating: false,
            tank_cleaning: false,
            cargo_discharging: false,
            reefer_container: false,
            cargo_cooling: false,
            cargo_reliquification: false,
            cargo_discharging_kwh_meter: false,
            cargo_cooling_kwh_meter: false,
            cargo_heating_kwh_meter: false,
            tank_cleaning_kwh_meter: false,
            reefer_container_kwh_meter: false,
            cargo_reliquification_kwh_meter: false,
          })
        }
      });
      setSpecialOperationsFuel(newSpecialOperationsFuel);
    }
  }, [VesselID, vesselMachineryFC]);

  useEffect(() => {
    if (vesselMachineryEC.length > 0) {
      vesselMachineryEC.map((machine: any, index: number) => {
        if (specialOperationsEnergy.length <= vesselMachineryEC.length) {
          specialOperationsEnergy.splice(index, 0, {
            vessel_name: VesselID, vessel_machinery_ec_group: machine.id, cargo_heating: false, tank_cleaning: false, cargo_discharging: false, reefer_container: false, cargo_cooling: false, cargo_reliquification: false, cargo_discharging_kwh_meter: false, cargo_cooling_kwh_meter: false, cargo_heating_kwh_meter: false, tank_cleaning_kwh_meter: false, reefer_container_kwh_meter: false, cargo_reliquification_kwh_meter: false,
          })
        }
        return '';
      })
    }
  }, [VesselID, specialOperationsEnergy, vesselMachineryEC]);

  function handleCargoHeatingChanges(e: any, idx: number) {
    if (e.target.name === 'fuel') {
      specialOperationsFuel[idx].cargo_heating = e.target.checked;

    } else if (e.target.name === 'energy') {
      specialOperationsEnergy[idx].cargo_heating = e.target.checked;
    }
  }

  function handleTankCleaningChanges(e: any, idx: number) {
    if (e.target.name === 'fuel') {
      specialOperationsFuel[idx].tank_cleaning = e.target.checked;
    } else if (e.target.name === 'energy') {
      specialOperationsEnergy[idx].tank_cleaning = e.target.checked;
    }
  }

  function handleCargoDischargingChanges(e: any, idx: number) {
    if (e.target.name === 'fuel') {
      specialOperationsFuel[idx].cargo_discharging = e.target.checked;
    } else if (e.target.name === 'energy') {
      specialOperationsEnergy[idx].cargo_discharging = e.target.checked;
    }
  }

  function handleReeferContainerChanges(e: any, idx: number) {
    if (e.target.name === 'fuel') {
      specialOperationsFuel[idx].reefer_container = e.target.checked;
    } else if (e.target.name === 'energy') {
      specialOperationsEnergy[idx].reefer_container = e.target.checked;
    }
  }

  function handleCargoCoolingChanges(e: any, idx: number) {
    if (e.target.name === 'fuel') {
      specialOperationsFuel[idx].cargo_cooling = e.target.checked;
    }
    else if (e.target.name === 'energy') {
      specialOperationsEnergy[idx].cargo_cooling = e.target.checked;
    }
  }

  function handleCargoReliquificationChanges(e: any, idx: number) {
    if (e.target.name === 'fuel') {
      specialOperationsFuel[idx].cargo_reliquification = e.target.checked;
    } else if (e.target.name === 'energy') {
      specialOperationsEnergy[idx].cargo_reliquification = e.target.checked;
    }
  }

  const SpecialOperationsFuelSettingsSubmit = (e: any) => {
    apiGlobal.post(`/special_operation_fuel_setting/`, specialOperationsFuel).then(res => {
      successToast("Data saved successfully!");
    })
      .catch(err => {
        console.log(err);
      });
  }

  const SpecialOperationsEnergySettingsSubmit = (e: any) => {
    apiGlobal.post(`/special_operation_energy_setting/`, specialOperationsEnergy).then(res => {
      successToast("Data saved successfully!");
    }).catch(err => {
      console.log(err);
    });
  }

  return (
    <>
      {vessel && (vessel.vessel_type === 'Tanker' || vessel.vessel_type === 'Container' || vessel.vessel_type === 'Gas Carrier' || vessel.vessel_type === 'LNG Carrier') ? (
        <>
          {vesselMachineryFC.length > 0 && (
            <Row>
              <Col>
                {vessel.vessel_type === 'Tanker' ? (
                  <>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead className="table-light">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Machinery name</th>
                            <th>Cargo heating</th>
                            <th>Tank cleaning</th>
                            <th>Cargo discharging</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vesselMachineryFC.map((vesselMachinery: any, index: number) => {
                            return (
                              <tr key={vesselMachinery.id}>
                                <td>{index + 1}</td>
                                <td>{vesselMachinery.vessel_machinery_fc_group_name}</td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='fuel'
                                      onChange={(e: any) => handleCargoHeatingChanges(e, index)}
                                      defaultChecked={specialOpsFC.length > 0 ? specialOpsFC.some((item: any) => item.vessel_machinery_fc_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx2"
                                      name='fuel'
                                      onChange={(e: any) => handleTankCleaningChanges(e, index)}
                                      defaultChecked={specialOpsFC.length > 0 ? specialOpsFC.some((item: any) => item.vessel_machinery_fc_group === vesselMachinery.id && item.tank_cleaning) : false}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx3"
                                      name='fuel'
                                      onChange={(e: any) => handleCargoDischargingChanges(e, index)}
                                      defaultChecked={specialOpsFC.length > 0 ? specialOpsFC.some((item: any) => item.vessel_machinery_fc_group === vesselMachinery.id && item.cargo_discharging) : false}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                      <Button type="button" color='primary' className='pos-end' onClick={(e) => { SpecialOperationsFuelSettingsSubmit(e) }}>Save</Button>
                    </div>
                  </>
                ) : vessel.vessel_type === 'Container' ? (
                  <>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead className="table-light">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Machinery name</th>
                            <th>Reefer Container</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vesselMachineryFC.map((vesselMachinery: any, index: number) => {
                            return (
                              <tr key={vesselMachinery.id}>
                                <td>{index + 1}</td>
                                <td>{vesselMachinery.vessel_machinery_fc_group_name}</td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='fuel'
                                      onChange={(e: any) => handleReeferContainerChanges(e, index)}
                                      defaultChecked={specialOpsFC.length > 0 ? specialOpsFC.some((item: any) => item.vessel_machinery_fc_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                      <Button type="button" color='primary' className='pos-end' onClick={(e) => { SpecialOperationsFuelSettingsSubmit(e) }}>Save</Button>
                    </div>
                  </>
                ) : (vessel.vessel_type === 'Gas Carrier' || vessel.vessel_type === 'LNG Carrier') ? (
                  <>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead className="table-light">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Machinery name</th>
                            <th>Cargo Cooling</th>
                            <th>Cargo Reliquification</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vesselMachineryFC.map((vesselMachinery: any, index: number) => {
                            return (
                              <tr key={vesselMachinery.id}>
                                <td>{index + 1}</td>
                                <td>{vesselMachinery.vessel_machinery_fc_group_name}</td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='fuel'
                                      onChange={(e: any) => handleCargoCoolingChanges(e, index)}
                                      defaultChecked={specialOpsFC.length > 0 ? specialOpsFC.some((item: any) => item.vessel_machinery_fc_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='fuel'
                                      onChange={(e: any) => handleCargoReliquificationChanges(e, index)}
                                      defaultChecked={specialOpsFC.length > 0 ? specialOpsFC.some((item: any) => item.vessel_machinery_fc_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                      <Button type="button" color='primary' className='pos-end' onClick={(e) => { SpecialOperationsFuelSettingsSubmit(e) }}>Save</Button>
                    </div>
                  </>
                ) : (
                  null
                )}
              </Col>
            </Row>
          )}

          {vesselMachineryEC.length > 0 ? (
            <Row>
              <Col>
                {vessel.vessel_type === 'Tanker' ? (
                  <>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead className="table-light">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Machinery name</th>
                            <th>Cargo heating</th>
                            <th>Tank cleaning</th>
                            <th>Cargo discharging</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vesselMachineryEC.map((vesselMachinery: any, index: number) => {
                            return (
                              <tr key={vesselMachinery.id}>
                                <td>{index + 1}</td>
                                <td>{vesselMachinery.vessel_machinery_ec_group_name}</td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='energy'
                                      onChange={(e: any) => handleCargoHeatingChanges(e, index)}
                                      defaultChecked={specialOpsEC.length > 0 ? specialOpsEC.some((item: any) => item.vessel_machinery_ec_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx2"
                                      name='energy'
                                      onChange={(e: any) => handleTankCleaningChanges(e, index)}
                                      defaultChecked={specialOpsEC.length > 0 ? specialOpsEC.some((item: any) => item.vessel_machinery_ec_group === vesselMachinery.id && item.tank_cleaning) : false}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx3"
                                      name='energy'
                                      onChange={(e: any) => handleCargoDischargingChanges(e, index)}
                                      defaultChecked={specialOpsEC.length > 0 ? specialOpsEC.some((item: any) => item.vessel_machinery_ec_group === vesselMachinery.id && item.cargo_discharging) : false}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                      <Button type="button" color='primary' className='pos-end' onClick={(e) => { SpecialOperationsEnergySettingsSubmit(e) }}>Save</Button>
                    </div>
                  </>
                ) : vessel.vessel_type === 'Container' ? (
                  <>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead className="table-light">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Machinery name</th>
                            <th>Reefer Container</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vesselMachineryEC.map((vesselMachinery: any, index: number) => {
                            return (
                              <tr key={vesselMachinery.id}>
                                <td>{index + 1}</td>
                                <td>{vesselMachinery.vessel_machinery_ec_group_name}</td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='energy'
                                      onChange={(e: any) => handleReeferContainerChanges(e, index)}
                                      defaultChecked={specialOpsEC.length > 0 ? specialOpsEC.some((item: any) => item.vessel_machinery_ec_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                      <Button type="button" color='primary' className='pos-end' onClick={(e) => { SpecialOperationsEnergySettingsSubmit(e) }}>Save</Button>
                    </div>
                  </>
                ) : (vessel.vessel_type === 'Gas Carrier' || vessel.vessel_type === 'LNG Carrier') ? (
                  <>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead className="table-light">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Machinery name</th>
                            <th>Cargo Cooling</th>
                            <th>Cargo Reliquification</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vesselMachineryEC.map((vesselMachinery: any, index: number) => {
                            return (
                              <tr key={vesselMachinery.id}>
                                <td>{index + 1}</td>
                                <td>{vesselMachinery.vessel_machinery_ec_group_name}</td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='energy'
                                      onChange={(e: any) => handleCargoCoolingChanges(e, index)}
                                      defaultChecked={specialOpsEC.length > 0 ? specialOpsEC.some((item: any) => item.vessel_machinery_ec_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="form-check mb-3">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="chckbx1"
                                      name='energy'
                                      onChange={(e: any) => handleCargoReliquificationChanges(e, index)}
                                      defaultChecked={specialOpsEC.length > 0 ? specialOpsEC.some((item: any) => item.vessel_machinery_ec_group === vesselMachinery.id && item.cargo_heating) : false}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div className="d-flex flex-wrap btn_Margin">
                      <Button type="button" color='primary' className='pos-end' onClick={(e) => { SpecialOperationsEnergySettingsSubmit(e) }}>Save</Button>
                    </div>
                  </>) : (
                  <Label>Please add energy consumer machinery to this vessel</Label>
                )}
              </Col>
            </Row>
          ) : null}
        </>
      ) : (
        <Label>No special operations are available for {vessel && vessel.vessel_type}</Label>
      )}
    </>
  )
}
